import NovalueCheck from './NoValueCheck';

export default (value, age, gender) => {

  if(gender == '1') gender = 'male';
  if(gender == '0') gender = 'female';

  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;
  age = +age;
  var max = 0, min = 0;

  if(age < 0.00016) {
    max = 0.88;
    min = 0.31;
  } 
  else if(age < 0.0027) {
    max = 0.4;
    min = 0.2;
  } 
  else if(age <= 5) {
    max = 0.6;
    min = 0.4;
  }
  else if(age <= 10) {
    if(gender === 'male') {
      max = 0.7;
      min = 0.5;
    } else {
      max = 0.7;
      min = 0.4;
    }
  }
  else if(age <= 14) {
    if(gender === 'male') {
      max = 0.8;
      min = 0.5;
    } else {
      max = 0.8;
      min = 0.5;
    }
  }
  else if(age <= 14) {
    if(gender === 'male') {
      max = 0.8;
      min = 0.5;
    } else {
      max = 0.8;
      min = 0.5;
    }
  }
  else if(age <= 20) {
    if(gender === 'male') {
      max = 1;
      min = 0.6;
    } else {
      max = 0.9;
      min = 0.6;
    }
  } else {
    if(gender === 'male') {
      max = 1.18;
      min = 0.73;
    } else {
      max = 1.02;
      min = 0.55;
    }
  }


  if(value > max) {
    return { 
      title: 'ค่ามากผิดปกติ',
      color: 'red',
      caption: 'ค่ามากผิดปกติ',
      suggest: ''
    };
  } else if(value < min) {
    return { 
      title: 'ค่าน้อยผิดปกติ',
      color: 'red',
      caption: 'ค่าน้อยผิดปกติ',
      suggest: ''
    };
  } else {
    return { 
      title: 'อยู่ในเกณฑ์ปกติ',
      color: 'green',
      caption: 'อยู่ในเกณฑ์ปกติ',
      suggest: ''
    };
  }
}